import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { risks } from '../data/content';
export function Risks() {
  return <section id="riesgos" className="w-full bg-forest-800 py-16 lg:py-24" data-id="element-164" data-mp="n7wxc69fo6la">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-165" data-mp="i6pos4zgv3dk">
        <div className="max-w-3xl" data-id="element-166" data-mp="i9bxi7y3foxd">
          <p className="flex items-center gap-2 font-display text-sm font-bold text-gold-500" data-id="element-167" data-mp="d8xqmt88al0x">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-168" data-mp="97ch9huwkovh" />
            El costo de seguir igual
          </p>
          <h2 className="display-tight mt-4 font-display text-4xl font-extrabold text-cream-50 sm:text-5xl" style={{
          color: "#BE0101"
        }} data-id="element-169" data-mp="4f2qjzlyrks5">
            ¿Qué puede pasar si seguís administrando tu dinero sin un sistema?
          </h2>
        </div>

        <ol className="mt-12 grid gap-x-14 border-t border-white/10 lg:grid-cols-2" data-id="element-170" data-mp="3qlhjplf5o9yn">
          {risks.map(risk => <li key={risk.n} className="border-b border-white/10 py-7 lg:py-8" data-id="element-171" data-mp="3hmw15q9oouxv">
              <div className="flex gap-5" data-id="element-172" data-mp="3dsjyhit4x7vh">
                <span aria-hidden="true" className="font-display text-xl font-extrabold text-gold-500" style={{
              color: "#E60A1C"
            }} data-id="element-173" data-mp="3driakdr0sqwc">
                  {risk.n}
                </span>
                <div data-id="element-174" data-mp="33x8hsuy61ql3">
                  <h3 className="font-display text-lg font-bold leading-snug text-cream-50 sm:text-xl" style={{
                color: "#E70729"
              }} data-id="element-175" data-mp="33tko9vsq146d">
                    {risk.title}
                  </h3>
                  <p className="mt-2.5 leading-relaxed text-cream-200" data-id="element-176" data-mp="clx71qv4fie">
                    {risk.copy}
                  </p>
                </div>
              </div>
            </li>)}
        </ol>

        <p className="mt-12 max-w-3xl border-l-2 border-gold-500 pl-5 text-lg leading-relaxed text-cream-100" data-id="element-177" data-mp="3nlqzkrgue1pr">
          Ninguno de estos problemas se resuelve ganando más: se resuelven con
          un sistema que le dé un destino a cada peso antes de gastarlo.
        </p>
      </div>
    </section>;
}